import './follow.scss';

const FollowComponent = {
  el: null,

  init() {
    this.el = document.querySelectorAll('[follow]');
    this.el.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.handleClick(btn);
      });
    });
  },

  handleClick(btn) {
    this.closeOpenOptions(btn);

    let option = btn.querySelectorAll('.options')[0];
    option.classList.toggle('open');
    btn.classList.toggle('expanded');

    this.hideOnClickOutside(btn, option);
  },

  closeOpenOptions(ancestor) {
    let openOptions = document.querySelectorAll('.open');

    if (openOptions) {
      openOptions.forEach((option) => {
        if (option.parentNode === ancestor) { return; }

        option.classList.remove('open');
      });
    }
  },

  hideOnClickOutside(element, dropdown) {
    const outsideClickListener = event => {
      if (!element.contains(event.target) && isVisible(element)) {
        dropdown.classList.remove('open');
        element.classList.remove('expanded');
        removeClickListener()
      }
    }

    const removeClickListener = () => {
      document.removeEventListener('click', outsideClickListener)
    }

    document.addEventListener('click', outsideClickListener)
    const isVisible = elem => !!elem && !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length )
  }
};

export default FollowComponent;